import cookie from "js-cookie";
import {parseByKey} from "@/utils/roomsAdapter";

const ROOM_KEY = "lcy_room_key"

export function setRoom(room) {
    cookie.set(ROOM_KEY, room.key)
}


export function getRoom() {
    let fromCookie = cookie.get(ROOM_KEY)
    if (fromCookie === undefined) return {}
    return parseByKey(fromCookie)
}
